import axios from '@/utils/request.js'

export const getDetail = (params) => { // 获取公司详情
  return axios.post(`goods/gas/company/getDetail/${params}`)
}

export const employeeList = (companyId) => { // 人员列表
  return axios.post('goods/gas/employee/listByCompanyId', { companyId })
}

export const addCompanyEmp = (params) => { // 添加公司人员
  return axios.post('goods/gas/company/addCompanyEmp', params)
}

export const delCompanyAdmin = (params) => { // 删除公司人员
  return axios.post('goods/gas/company/delCompanyAdmin', params)
}

export const updateCompany = (params) => { // 提交修改
  return axios.post('goods/gas/company/update', params)
}
